import { render, staticRenderFns } from "./PartyAntifraud.vue?vue&type=template&id=b52e5ce6"
import script from "./PartyAntifraud.vue?vue&type=script&lang=js"
export * from "./PartyAntifraud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports